<script>
    import { api_host, all_users_store, user_store, page_setting_store } from "../../stores.js";
    import { init_data } from '../../init.js';
    import { state_codes } from '../../globals.js';
    import { querystring } from 'svelte-spa-router';
    import { onMount } from 'svelte';
    import Header from "../header.svelte";
    import { pop, push } from 'svelte-spa-router';
    import IFTAInput from "../../utils/iftainput.svelte";
    import { getToken, doFetch } from "../../utils/Fetching.js";
    import { toast_message } from '../../utils/toast_message.js';
    import Itemselector from "../../utils/itemselector.svelte";
    import { formatDate, handle_not_subscribed, deepCopy } from "../../utils/format.js";
    import { getTax, get_main_service_price, get_extra_service_prices, convert_tax_rates, description_validation_func, rate_validation_func, price_validation_func, quantity_validation_func } from '../../utils/tax.js';
    import Swal from "sweetalert2";


    const { auth_type, auth_token, domain_code } = getToken();

    let job = {};
    let content_title = "Editing Job";
    let crew_selection_error_msg = 'Crew is required';
    let is_crew_check_first = true;
    let jid = "";
    let is_busy = false;
    let crew_items = [];
    let myself = {};
    let config_lawn_settings = [];
    let config_service_settings = [];
    let config_service_type_settings = [];
    let photos = [], fileinput;
    let tax_rate_options = [];
    let tax_rates = [];
    let extra_service_price_list = [];
    let extra_contractor_price_list = [];

    const onFileSelected = (e) => {
        const files = Array.from(e.target.files);
        files.forEach(file => {
            console.log('file', file);

            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = e => {
                let image = new Image();
                image.src = e.target.result;
                image.onload = () => {

                    let canvas = document.createElement('canvas');
                    let context = canvas.getContext('2d');

                    // Set the canvas dimensions to the desired downscaled size
                    let downscaledWidth = 400; // Adjust to your desired width
                    let downscaledHeight = (image.height / image.width) * downscaledWidth;
                    canvas.width = downscaledWidth;
                    canvas.height = downscaledHeight;

                    // Draw the image onto the canvas with the downscaled size
                    context.drawImage(image, 0, 0, downscaledWidth, downscaledHeight);

                    // Convert the downscaled image on the canvas to a base64 data URL with reduced quality
                    let downscaledDataURL = canvas.toDataURL('image/jpeg', 0.8); // Adjust quality as needed

                    photos = [
                        ...photos, 
                        {
                            filename: file.name,
                            body: downscaledDataURL
                        }
                    ];
                    console.log('downgraded', photos);
                }
            };
        });
    };

    const onFileRemoved = async (index) => {
        const result = await Swal.fire({
            title: "Are you sure you want to delete this photo?",
            text: '',
            buttonsStyling: true,
            confirmButtonClass: "button",
            confirmButtonText: 'Ok',
            cancelButtonText: "Cancel",
            showCancelButton: true,
            icon: "warning"
        });
        if (!result.isConfirmed) return;
        
        const photo = photos[index];
        if (photo.uploaded) {
            photo.deleted = true;
        } else {
            photos.splice(index);
        }
        photos = photos;
    };

    const upload_images = async (photos, tag) => {
        const urls = [];
        for (let i = 0; i < photos.length; i++) {
            const photo = photos[i];
            const payload = {
                tag,
                image: photo.body,
                filename: photo.filename
            };
            const { auth_type, auth_token, domain_code } = getToken();
            const res = await doFetch(
                `${api_host}/api/upload/image`,
                'POST',
                payload,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.url) urls.push(res.url);
        }
        return urls;
    };

    const remove_image = async (url) => {
        const { auth_type, auth_token, domain_code } = getToken();
        const res = await doFetch(
            `${api_host}/api/upload/image/remove`,
            'POST',
            {
                url
            }, 
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
    };

    user_store.subscribe(value => {
        myself = value;
    });

    $: is_employee_exists = crew_items.filter(item => item.role === 'employee' && item.a).length > 0;

    all_users_store.subscribe(async (value) => {
        if (Object.keys(value).length) {
            const crews = value.filter(user => (user.role == 'contractor' || user.role == 'employee' || user.role === 'landscaper') && user.is_active);
            let selected_role = '';
            if (job?.crew_users?.length) {
                selected_role = job.crew_users[0].role === 'landscaper' ? 'employee' : job.crew_users[0].role;
            }
            for (let i = 0; i < crews.length; i ++) {
                let is_existing = false;
                const crew = crews[i];
                if (job.crew_users && job.crew_users.length) {
                    const crew_user = job.crew_users.find(x => x.id == crew.id);
                    if (crew_user) { is_existing = true; }
                }
                const crew_role = crew.role === 'landscaper' ? 'employee' : crew.role;
                crew_items.push({
                    t: `${crew.first_name} ${crew.last_name}` + (crew.role === 'landscaper' ? ' (Owner)' : ''),
                    a: is_existing,
                    uid: crew.id,
                    role: crew_role,
                    hours: 0,
                    notes: '',
                    disabled: ((selected_role !== '' && crew_role !== selected_role) || (selected_role === 'contractor' && crew_role === 'contractor' && crew.uid !== job.crew_users[0].id))
                });
            }
        }

        const params = new URLSearchParams($querystring)

        if (params.has("jid")) {
            jid = params.get("jid");
            const res = await doFetch(
                `${api_host}/api/job/get/${jid}`,
                'GET',
                null,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );

            if (res.status) {
                job = res.job;
                if (job.state.length === 2) {
                    job.state = Object.keys(state_codes).find(code => state_codes[code] == job.state);
                }
                fields[0].value = job.paymethod;
                fields[4].value = '';
                fields[5].value = job.contractor_margin.toFixed(6);
                fields[6].value = job.contractor_price.toFixed(2);
                fields[7].value = job.service_type;
                fields[8].value = formatDate(job.service_date);
                fields[9].value = job.time_preference;
                fields[10].value = job.service_frequency;
                if (job.service_frequency === 'One-Time') {
                    fields[18].hidden = true;
                }
                fields[11].value = job.lawn;
                fields[12].value = job.last_service;
                fields[13].value = job.back_yard_entry;
                fields[14].value = job.additional_comments;
                fields[15].value = job.internal_comments;
                fields[16].value = job.extra_contractor_price.toFixed(2);
                fields[17].value = job.total_contractor_price.toFixed(2);
                fields[18].value = job.next_service_price.toFixed(2);
                fields[19].value = job.address;
                fields[20].value = job.city;
                fields[21].value = job.state;
                fields[22].value = job.zipcode;
                if (!is_employee_exists) {
                    if (!fields[6].value) {
                        fields[6].value = (parseFloat(fields[1].value || 0) * parseFloat(fields[5].value || 0)).toFixed(2);
                    }
                    if (!fields[17].value) {
                        fields[17].value = (parseFloat(fields[6].value || 0) + parseFloat(fields[16].value || 0)).toFixed(2);
                    }
                }
                if (crew_items.length) {
                    const temp_crew_items = [];
                    let selected_role = '';
                    if (job.crew_users?.length) {
                        selected_role = job.crew_users[0].role === 'landscaper' ? 'employee' : job.crew_users[0].role;
                    }
                    crew_items.map(crew_item => {
                        const crew_user = job.crew_users.find(x => x.id === crew_item.uid);
                        if (crew_user) { 
                            crew_item.a = true;
                            crew_item.hours = crew_user.hours;
                            crew_item.notes = crew_user.notes;
                        }
                        crew_item.disabled = (selected_role !== '' && selected_role !== crew_item.role) || (selected_role === 'contractor' && crew_item.role === 'contractor' && crew_item.uid !== job.crew_users[0].id);
                        temp_crew_items.push(crew_item);
                    });
                    crew_items = temp_crew_items;
                }
                tax_rate_options = res.tax_rate_options;

                if (job.service_prices.length > 0) {
                    const main_service_price = get_main_service_price(job.service_prices, tax_rate_options);
                    fields[1].value = main_service_price.rate;
                    fields[2].value = main_service_price.quantity;
                    tax_rates = main_service_price.tax_rates;

                    extra_service_price_list = get_extra_service_prices(job.service_prices, tax_rate_options);
                    extra_contractor_price_list = job.extra_contractor_prices;
                } else {
                    fields[1].value = job.service_price;
                    fields[2].value = 1;
                    if (job.extra_contractor_price > 0) {
                        extra_contractor_price_list.push({ description: "", price: job.extra_contractor_price});
                        extra_contractor_price_list = extra_contractor_price_list;
                    }
                }
                set_total_service_price(true);

                if (job.service_type !== "Yard/Lawn Service") {
                    fields[11].hidden = true;
                    fields[12].hidden = true;
                }
                photos = job.photos.map(url => ({
                    uploaded: true,
                    deleted: false,
                    body: url
                }));
            } else {
                toast_message(false, 'Fetching job details failed', 3000);
            }
        }
    });

    onMount(async () => {
    });

    const set_total_service_price = (is_loading = false) => {
        console.log("set_total_service_price", is_loading);
        fields[3].value = parseFloat(fields[1].value || 0) * parseFloat(fields[2].value || 0);

        let extra_service_price = 0;
        let extra_service_tax = 0;
        extra_service_price_list.forEach(item => {
            extra_service_price += item.rate * item.quantity;
            extra_service_tax += getTax(item.rate * item.quantity, item.tax_rates);
        });
        fields[23].value = (parseFloat(fields[3].value || 0) + extra_service_price).toFixed(2);
        
        let subtotal = parseFloat(fields[23].value || 0);
        let service_tax = getTax(fields[3].value, tax_rates) + extra_service_tax;
        
        fields[24].value = service_tax.toFixed(2);
        fields[25].value = (subtotal + service_tax).toFixed(2);

        // contractor prices
        if (!is_loading) {
            fields[6].value = (parseFloat(fields[3].value || 0) * parseFloat(fields[5].value || 0)).toFixed(2);
        }
        let extra_contractor_price = 0;
        extra_contractor_price_list.forEach(item => {
            extra_contractor_price += parseFloat(item.price || 0);
        });
        fields[16].value = extra_contractor_price;
        fields[17].value = parseFloat(fields[6].value || 0) + parseFloat(fields[16].value || 0);
    };
    
    let fields = [
        {
            "index": 0,
            "group": "pricing0",
            "type": "select",
            "label": "Payment Method",
            "value": "Credit Card",
            "select_options": ['Credit Card', 'Cash', 'Check'],
            "name": "job[payment_method]",
            "validation_function": () => {
                if (fields[0].value.length > 0) {
                    fields[0]['show_error'] = false;
                    return true;
                } else {
                    fields[0]['show_error'] = true;
                    fields[0]['error_text'] = 'Invalid Payment Method';
                    return false;
                }
            }
        },  {
            "index": 1,
            "group": "pricing",
            "type": "text",
            "label": "Rate $",
            "value": 0,
            "placeholder": "eg. 0.00",
            "name": "quote[service_rate]",
            "change_function": (evt) => {
                fields[1].value = parseFloat(evt.target.value).toFixed(2);
                set_total_service_price();
                if (fields[1].value > 0) {
                    fields[1]['show_error'] = false;
                } else {
                    fields[1]['show_error'] = false;
                    fields[1]['error_text'] = 'Service Rate is required';
                }
            },
            "validation_function": () => {
                if (parseFloat(fields[1].value) >= 0) {
                    fields[1]['show_error'] = false;
                    return true;
                } else {
                    fields[1]['show_error'] = true;
                    fields[1]['error_text'] = 'Service Rate is required';
                    return false;
                }
            }
        }, {
            "index": 2,
            "group": "pricing",
            "type": "text",
            "label": "Quantity",
            "value": 0,
            "placeholder": "eg. 0.00",
            "name": "quote[service_quantity]",
            "change_function": (evt) => {
                fields[2].value = parseFloat(evt.target.value).toFixed(2);
                set_total_service_price();
                if (fields[2].value > 0) {
                    fields[2]['show_error'] = false;
                } else {
                    fields[2]['show_error'] = false;
                    fields[2]['error_text'] = 'Service Rate is required';
                }
            },
            "validation_function": () => {
                if (parseFloat(fields[2].value) > 0) {
                    fields[2]['show_error'] = false;
                    return true;
                } else {
                    fields[2]['show_error'] = true;
                    fields[2]['error_text'] = 'Service Quantity is required';
                    return false;
                }
            }
        }, {
            "index": 3,
            "group": "pricing",
            "type": "text",
            "label": "Service Price $",
            "value": 0,
            "placeholder": "eg. 0.00",
            "name": "quote[service_price]",
            "validation_function": () => true,
            "disabled": true,
        }, {
            "index": 4,
            "group": "contractor_crews",
            "type": "select",
            "label": "Crew Names",
            "value": "",
            "select_options": ['-- No crew --'],
            "name": "job[crew_member]",
            "validation_function": () => { return true; }
        }, {
            "index": 5,
            "group": "contractor",
            "type": "text",
            "label": "Contractor Margin",
            "value": "",
            "name": "job[contractor_margin]",
            "change_function": (evt) => {
                if (parseFloat(fields[3].value) >= 0) {
                    fields[6].value = (parseFloat(fields[3].value || 0) * parseFloat(evt.target.value || 0)).toFixed(2);
                    fields[17].value = (parseFloat(fields[6].value || 0) + parseFloat(fields[16].value)).toFixed(2);
                }
            },
            "validation_function": () => {
                if (parseFloat(fields[5].value) >= 0) {
                    fields[5]['show_error'] = false;
                    return true;
                } else {
                    fields[5]['show_error'] = true;
                    fields[5]['error_text'] = 'Invalid Contractor Margin';
                    return false;
                }
            }
        }, {
            "index": 6,
            "group": "contractor",
            "type": "text",
            "label": "Contractor Price $",
            "value": "",
            "name": "job[contractor_price]",
            "change_function": (evt) => {
                fields[6].value = parseFloat(evt.target.value).toFixed(2);
                if (parseFloat(fields[3].value) > 0) {
                    fields[5].value = (parseFloat(evt.target.value || 0) / parseFloat(fields[3].value || 0)).toFixed(6);
                    fields[17].value = (parseFloat(evt.target.value || 0) + parseFloat(fields[16].value)).toFixed(2);
                }
            },
            "validation_function": () => {
                if (is_employee_exists) { return true; }
                if (parseFloat(fields[6].value) > 0) {
                    fields[6]['show_error'] = false;
                    return true;
                } else {
                    fields[6]['show_error'] = true;
                    fields[6]['error_text'] = 'Contract Price is required';
                    return false;
                }
            }
        }, {
            "index": 7,
            "group": "pricing0",
            "type": "select",
            "label": "Service Type",
            "value": "Yard/Lawn Service",
            "style": "min-width: 200px;",
            "change_function": (e) => {
                const new_val = e.target.value;
                if(new_val !== "Yard/Lawn Service") {
                    fields[11].hidden = true;
                    fields[12].hidden = true;
                }else{
                    fields[11].hidden = false;
                    fields[12].hidden = false;
                }
            },
            "select_options": ["Yard/Lawn Service", "Irrigation Service", "Tree Service", "Plant Service", "Hardscape Service", "Snow Service", "Other Service"],
            "name": "job[service]",
            "validation_function": () => {
                if (fields[7].value.length > 0) {
                    fields[7]['show_error'] = false;
                    return true;
                } else {
                    fields[7]['show_error'] = true;
                    fields[7]['error_text'] = 'Invalid Service Type';
                    return false;
                }
            }
        }, {
            "index": 8,
            "group": "service1",
            "type": "date",
            "label": "Service Date",
            "value": "",
            "name": "job[day_of_service]",
            "validation_function": () => {
                if (fields[8].value.length) {
                    fields[8]['show_error'] = false;
                    return true;
                } else {
                    fields[8]['show_error'] = true;
                    fields[8]['error_text'] = 'Service Date is required';
                    return false;
                }
            }
        }, {
            "index": 9,
            "group": "service1",
            "type": "select",
            "label": "Time Preference",
            "value": "",
            "select_options": ['No Preference', 'Morning', 'Afternoon', '6AM', '7AM', '8AM', '9AM', '10AM', '11AM', '12PM', '1PM', '2PM', '3PM', '4PM', '5PM', '6PM' ],
            "name": "job[time_preference]",
            "validation_function": () => { return true; }
        }, {
            "index": 10,
            "group": "service1",
            "type": "select",
            "label": "Service Frequency",
            "value": "",
            "select_options": ['Weekly', 'Bi-Weekly', 'Monthly', 'One-Time', 'Every 3 weeks', 'Every 6 weeks', 'Every 2 months' ],
            "name": "job[service_frequency]",
            "change_function": (evt) => {
                if (evt.target.value === 'One-Time') {
                    fields[18].hidden = true;
                } else {
                    fields[18].hidden = false;
                }
            },
            "validation_function": () => { return true; }
        }, {
            "index": 11,
            "group": "service2",
            "type": "select",
            "label": "Lawn",
            "value": "",
            "select_options": ['None', 'Front OR Back', 'Front AND Back'],
            "name": "job[lawn]",
            "validation_function": () => { return true; }
        }, {
            "index": 12,
            "group": "service2",
            "type": "select",
            "label": "Last Cleanup?",
            "value": "",
            "select_options": ['Less than 2 weeks ago', '2 to 4 weeks ago', '1 to 2 months ago', '3 months or more'],
            "name": "job[last_cleanup]",
            "validation_function": () => { return true; }
        }, {
            "index": 13,
            "group": "service2",
            "type": "select",
            "label": "Back Yard Entry Instructions",
            "value": "",
            "select_options": ['Already Open', 'Ring Door Bell', 'Not Required', 'Other'],
            "name": "job[back_yard_entry]",
            "validation_function": () => { return true; }
        }, {
            "index": 14,
            "group": "service3",
            "type": "textarea",
            "label": "Additional Comments",
            "value": "",
            "placeholder": "... any additional comments for this job.",
            "name": "job[comments]",
            "maxlength": 5000,
            "validation_function": () => { return true; }
        }, {
            "index": 15,
            "group": "service3",
            "type": "textarea",
            "label": "Internal Comments",
            "value": "",
            "placeholder": "... any internal comments for this job.",
            "name": "job[comments]",
            "maxlength": 5000,
            "validation_function": () => { return true; }
        }, {
            "index": 16,
            "group": "contractor",
            "type": "text",
            "label": "Extra Contractor Price $",
            "value": 0,
            "name": "job[extra_contractor_price]",
            "validation_function": () => true,
            "disabled": true,
        }, {
            "index": 17,
            "group": "contractor",
            "type": "text",
            "label": "Total Contractor Price $",
            "value": 0,
            "name": "job[total_contractor_price]",
            "validation_function": () => true,
            "disabled": true,
        }, {
            "index": 18,
            "group": "pricing",
            "type": "text",
            "label": "Next Service Price $",
            "value": "",
            "placeholder": "eg. 0.00",
            "name": "job[next_service_price]",
            "change_function": (evt) => {
                fields[18].value = parseFloat(evt.target.value).toFixed(2);
            },
            "validation_function": () => {
                if (fields[10].value === 'One-Time') {
                    fields[18]['show_error'] = false;
                    return true;
                }
                if (parseFloat(fields[18].value) > 0) {
                    fields[18]['show_error'] = false;
                    return true;
                } else {
                    fields[18]['show_error'] = true;
                    fields[18]['error_text'] = 'Invalid Next Service Price';
                    return false;
                }
            }
        }, {
            "index": 19,
            "group": "contact1",
            "type": "text",
            "label": "Address",
            "value": "",
            "placeholder": "eg. 123 My Street",
            "name": "job[address]",
            "validation_function": () => {
                if (fields[19].value.length) {
                    fields[19]['show_error'] = false;
                    return true;
                } else {
                    fields[19]['show_error'] = true;
                    fields[19]['error_text'] = 'Address is required';
                    return false;
                }
            },
            'disabled': true,
        }, {
            "index": 20,
            "group": "contact1",
            "type": "text",
            "label": "City",
            "value": "",
            "placeholder": "eg. Phoenix",
            "name": "job[city]",
            "validation_function": () => {
                if (fields[20].value.length) {
                    fields[20]['show_error'] = false;
                    return true;
                } else {
                    fields[20]['show_error'] = true;
                    fields[20]['error_text'] = 'City is required';
                    return false;
                }
            },
            "disabled": true
        }, {
            "index": 21,
            "group": "contact1",
            "type": "select",
            "label": "State",
            "value": "Arizona",
            "select_options": Object.keys(state_codes),
            "name": "job[state]",
            "validation_function": () => {
                if (fields[21].value.length) {
                    fields[21]['show_error'] = false;
                    return true;
                } else {
                    fields[21]['show_error'] = true;
                    fields[21]['error_text'] = 'Invalid State';
                    return false;
                }
            },
            "disabled": true
        }, {
            "index": 22,
            "group": "contact1",
            "type": "text",
            "label": "Zip Code",
            "value": "",
            "placeholder": "Optional (eg. 85001)",
            "name": "job[zipcode]",
            "validation_function": () => {
                const zipformat = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
                if (fields[22].value.length == 0) return true;
                if (fields[22].value.match(zipformat)) {
                    fields[22]['show_error'] = false;
                    return true;
                } else {
                    fields[22]['show_error'] = true;
                    fields[22]['error_text'] = 'Invalid zipcode';
                    return false;
                }
            }
        }, { 
            "index": 23,
            "group": "pricing2",
            "type": "text",
            "label": "Subtotal Price $",
            "value": 0,
            "placeholder": "eg. 0.00",
            "name": "quote[subtotal_price]",
            "hidden": false,
            "validation_function": () => true,
            "disabled": true,
        }, {
            "index": 24,
            "group": "pricing2",
            "type": "text",
            "label": "Tax $",
            "value": 0,
            "placeholder": "eg. 0.00",
            "name": "quote[tax_price]",
            "hidden": false,
            "validation_function": () => true,
            "disabled": true,
        }, {
            "index": 25,
            "group": "pricing2",
            "type": "text",
            "label": "Total Service Price $",
            "value": 0,
            "placeholder": "eg. 0.00",
            "name": "quote[total_service_price]",
            "hidden": false,
            "validation_function": () => {
                if (parseFloat(fields[25].value) >= 0) {
                    fields[25]['show_error'] = false;
                    return true;
                } else {
                    fields[25]['show_error'] = true;
                    fields[25]['error_text'] = 'Total Service Price is required';
                    return false;
                }
            },
            "disabled": true,
        },
    ];

    page_setting_store.subscribe(page_setting => {
        if(page_setting.lawn_options == undefined) return;
        config_lawn_settings = Object.keys(page_setting.lawn_options);
        config_service_settings = Object.keys(page_setting.service_frequency_options);
        config_service_type_settings = Object.keys(page_setting.service_type_options);
        console.log('config lawn settings', config_lawn_settings);
        console.log('config service settings', config_service_settings);
        config_service_settings.unshift('');
        const freequencies = ["Every 3 weeks", "Every 6 weeks", "Every 2 months"];
        freequencies.forEach(f => config_service_settings.push(f));

        fields[10].select_options = config_service_settings;
        fields[11].value = config_lawn_settings.length > 0 ? config_lawn_settings[0] : '';
        fields[11].select_options = config_lawn_settings;
        fields[7].select_options = config_service_type_settings;
    });

    let validateForm = () => {
        let is_valid = true;
        fields.forEach(field => {
            if (!field.validation_function()) { is_valid = false; }
        })

        if (myself.plan_type !== 'basic') {
            if (crew_items.filter(item => item.a).length === 0) {
                is_valid = false;
                is_crew_check_first = false;
            }
        }

        extra_service_price_list.forEach(item => {
            if (!description_validation_func(item)) {
                console.log('validate error:', item);
                is_valid = false;
            }
            if (!rate_validation_func(item)) {
                console.log('validate error:', item);
                is_valid = false;
            }
            if (!quantity_validation_func(item)) {
                console.log('validate error:', item);
                is_valid = false;
            }
        });
        extra_service_price_list = extra_service_price_list;

        extra_contractor_price_list.forEach(item => {
            if (!description_validation_func(item)) {
                console.log('validate error:', item);
                is_valid = false;
            }
            if (!price_validation_func(item)) {
                console.log('validate error:', item);
                is_valid = false;
            }
        });
        extra_contractor_price_list = extra_contractor_price_list;
        
        return is_valid;
    };
    
    let updateJob = async () => {
        if (!myself['is_subscribed']) {
            handle_not_subscribed(myself.is_authenticated, myself.is_domain_expired);
            return;
        }
        if (validateForm()) {
            is_busy = true;
            const urls = [];
            for (let i = 0; i < photos.length; i++) {
                const photo = photos[i];
                if (photo.uploaded) {
                    if (photo.deleted) {
                        await remove_image(photo.body);
                    } else {
                        urls.push(photo.body);
                    }
                } else {
                    const uploadedUrls = await upload_images([photo], 'quote');
                    urls.push(uploadedUrls[0]);
                }
            }

            const service_prices = deepCopy(extra_service_price_list);
            service_prices.push({
                "description": "",
                "rate": fields[1].value,
                "quantity": fields[2].value,
                "tax_rates": tax_rates,
                "is_main": true
            });
            const payload = {
                job_id: jid,
                paymethod: fields[0].value,
                contractor_margin: fields[5].value,
                contractor_price: is_employee_exists ? 0 : fields[6].value,
                extra_contractor_price: is_employee_exists ? 0 : fields[16].value,
                total_contractor_price: is_employee_exists ? 0 : fields[17].value,
                service_type: fields[7].value,
                service_date: formatDate(fields[8].value),
                next_service_price: fields[18].value,
                time_preference: fields[9].value,
                service_frequency: fields[10].value,
                lawn: fields[11].value,
                last_service: fields[12].value,
                back_yard_entry: fields[13].value,
                additional_comments: fields[14].value,
                internal_comments: fields[15].value,
                address: fields[19].value,
                city: fields[20].value,
                state: fields[21].value,
                zipcode: fields[22].value,
                crews: crew_items.filter(item => item.a),
                photos: urls,
                service_price: fields[3].value,
                total_service_price: fields[25].value,
                service_prices,
                extra_contractor_prices: extra_contractor_price_list,
            };
            const res = await doFetch(
                `${api_host}/api/job/update`,
                'POST',
                payload,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.status) {
                init_data('jobs');
                toast_message(true, res.msg, 2000);
                push(`#/Job_Review?jid=${jid}`);
            } else {
                toast_message(false, res.msg || 'Bad request', 2000);
            }
            is_busy = false;
        } else {
            toast_message(false, 'Missing or invalid info', 2000);
        }
    };
</script>

<Header bind:title={content_title} bind:is_busy={is_busy} />

<div class="contentholder">
    <div class="section clientinfo">
        <div class="sectiontitle"><i class="fas fa-user"></i> Client Information</div>
        <div class="sectioninfo">
                <div class="infoitem">
                    <div class="infoitemtitle">Name:</div>
                    <div class="infoitemvalue"><a href={`#/User_Review?uid=${job.uid}`}>{`${job.first_name} ${job.last_name}`}</a></div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Address:</div>
                    <div class="infoitemvalue">{`${job.address}, ${job.city}, ${job.state}`}</div>
                </div>
        </div>
    </div>
    <div class="section pricinginfo">
        <div class="sectiontitle"><i class="fas fa-dollar-sign"></i> Pricing Information</div>
        <div class="ff pricinginforow">
            {#each fields.filter((e)=>e.group === "pricing0") as nf}
            <IFTAInput 
                type={(nf.type !== undefined) ? nf.type : ""}
                label={(nf.label !== undefined) ? nf.label : ""}
                placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""}
                helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""}
                select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                name={nf.name}
                show_error={nf.show_error}
                error_text={nf.error_text}
                style={nf.style}
                bind:value={nf.value}
                bind:change_function={nf.change_function}
                bind:validation_function={nf.validation_function}
                bind:extFuncs={nf.ext_funcs}
                bind:hidden={nf.hidden}
            />
            {/each}
            {#each fields.filter((e)=>e.group === "pricing") as nf}
            <IFTAInput 
                type={(nf.type !== undefined) ? nf.type : ""} 
                label={(nf.label !== undefined) ? nf.label : ""} 
                placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                name={nf.name}
                show_error={nf.show_error}
                error_text={nf.error_text}
                bind:change_function={nf.change_function}
                bind:value={nf.value}
                bind:hidden={nf.hidden}
                bind:validation_function={nf.validation_function}
                bind:extFuncs={nf.ext_funcs}
                bind:disabled={nf.disabled}
            />
            {/each}
            <div class="mockgroupitem">
                <Itemselector 
                    title="Tax Rates"
                    bind:items={tax_rates}
                    collapsible={true}
                    changed={set_total_service_price}
                />
            </div>
        </div>
        <div class="ff">
            <button on:click={()=>{ 
                extra_service_price_list.push({ description: "", rate: 0, quantity: 1, price: 0, tax_rates: convert_tax_rates([], tax_rate_options)});
                extra_service_price_list = extra_service_price_list;
            }} style="background-color: #1769aa; color: white;" disabled={is_busy}>
                <i class="fa-plus" style="font-style: normal;"></i> 
                Extra Service
            </button>
            {#each extra_service_price_list as item, index}
            <div class="formrow">
                <IFTAInput 
                    type={"textarea"}
                    label={"Description"}
                    placeholder={""}
                    maxlength={5000}
                    bind:value={item.description}
                    show_error={item.description_show_error}
                    error_text={item.description_error_text}
                    validation_function={() => description_validation_func(item)}
                />
                <IFTAInput 
                    type={"text"}
                    label={"Rate $"}
                    bind:value={item.rate}
                    show_error={item.rate_show_error}
                    error_text={item.rate_error_text}
                    change_function={(evt) => {
                        item.rate = evt.target.value;
                        item.price = item.rate * item.quantity;
                        set_total_service_price();
                    }}
                    validation_function={() => rate_validation_func(item)}
                />
                <IFTAInput 
                    type={"text"}
                    label={"Quantity"}
                    bind:value={item.quantity}
                    show_error={item.quantity_show_error}
                    error_text={item.quantity_error_text}
                    change_function={(evt) => {
                        item.quantity = evt.target.value;
                        item.price = item.rate * item.quantity;
                        set_total_service_price();
                    }}
                    validation_function={() => quantity_validation_func(item)}
                />
                <div class="mockgroupitem">
                    <Itemselector 
                        title="Tax Rates"
                        bind:items={item.tax_rates}
                        collapsible={true}
                        changed={set_total_service_price}
                    />
                </div>
                <IFTAInput 
                    type={"text"}
                    label={"Price $"}
                    bind:value={item.price}
                    disabled={true}
                />
                <button on:click={()=>{ 
                    extra_service_price_list.splice(index, 1); 
                    extra_service_price_list = extra_service_price_list;
                    set_total_service_price();
                }} class="btn-icon"><i class="fas fa-trash"></i></button>
            </div>
            {/each}
            
        </div>
        <div class="ff formrow" style="width: 50%;margin-left: 50%;">
            {#each fields.filter((e)=>e.group === "pricing2") as nf}
            <IFTAInput 
                type={(nf.type !== undefined) ? nf.type : ""}
                label={(nf.label !== undefined) ? nf.label : ""}
                placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""}
                helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""}
                select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                name={nf.name}
                show_error={nf.show_error}
                error_text={nf.error_text}
                bind:value={nf.value}
                bind:change_function={nf.change_function}
                bind:validation_function={nf.validation_function}
                bind:extFuncs={nf.ext_funcs}
                bind:hidden={nf.hidden}
                bind:disabled={nf.disabled}
            />
            {/each}
        </div>
    </div>
    <div class="section contractorinfo">
        <div class="sectiontitle"><i class="fas fa-truck-pickup"></i> Crew Information</div>
        <div class="ff contractorinforow">
            <div class="mockgroupitem">
                <Itemselector 
                    title="Crew Names"
                    bind:items={crew_items}
                    collapsible={true}
                    bind:error_msg={crew_selection_error_msg}
                    bind:is_crew_check_first={is_crew_check_first}
                />
            </div>
            {#each fields.filter((e) => e.group === "contractor") as nf}
            <IFTAInput 
                type={!is_employee_exists ? ((nf.type !== undefined) ? nf.type : "") : 'hidden'}
                label={!is_employee_exists ? ((nf.label !== undefined) ? nf.label : "") : ''}
                placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                name={nf.name}
                show_error={nf.show_error}
                error_text={nf.error_text}
                bind:change_function={nf.change_function}
                bind:value={nf.value}
                bind:disabled={nf.disabled}
                bind:validation_function={nf.validation_function}
                bind:extFuncs={nf.ext_funcs}
            />
            {/each}
        </div>
        {#if !is_employee_exists}
        <div class="ff">
            <button on:click={()=>{ 
                extra_contractor_price_list.push({ description: "", price: 0});
                extra_contractor_price_list = extra_contractor_price_list;
            }} style="background-color: #1769aa; color: white;" disabled={is_busy}>
                <i class="fa-plus" style="font-style: normal;"></i> 
                Extra Contractor Price
            </button>
            {#each extra_contractor_price_list as item, index}
            <div class="formrow">
                <IFTAInput 
                    type={"textarea"}
                    label={"Description"}
                    placeholder={""}
                    maxlength={5000}
                    bind:value={item.description}
                    show_error={item.description_show_error}
                    error_text={item.description_error_text}
                    validation_function={() => description_validation_func(item)}
                />
                <IFTAInput 
                    type={"text"}
                    label={"Price $"}
                    bind:value={item.price}
                    show_error={item.price_show_error}
                    error_text={item.price_error_text}
                    change_function={(evt) => {
                        item.price = evt.target.value;
                        set_total_service_price();
                    }}
                    validation_function={() => price_validation_func(item)}
                />
                <button on:click={()=>{ 
                    extra_contractor_price_list.splice(index, 1); 
                    extra_contractor_price_list = extra_contractor_price_list;
                    set_total_service_price();
                }} class="btn-icon"><i class="fas fa-trash"></i></button>
            </div>
            {/each}
            
        </div>
        {/if}
    </div>
    {#if is_employee_exists}
    <div class="section timesheetinfo">
        <div class="sectiontitle"><i class="fal fa-user-hard-hat"></i> Timesheet</div>
        <div class="sectioninfo">
            
            <table>
                <tr>
                    <th>Crew name</th>
                    <th>Hours</th>
                    <th>Notes</th>
                </tr>
                {#each crew_items.filter(it => it.role === 'employee' && it.a) as item}
                <tr>
                    <td>{ item.t }</td>
                    <td><input type="number" bind:value={item.hours} min="0" style="width: 60px; border-radius: 4px;"></td>
                    <td><textarea rows=1 bind:value={item.notes} style="border-radius: 4px; margin-top: 6px;"></textarea></td>
                </tr>
                {/each}
            </table>
        </div>
    </div>
    {/if}
    <div class="section serviceinfo">
        <div class="sectiontitle"><i class="fas fa-info-circle"></i> Service Information</div>
        <div class="ff serviceinforow">
            {#each fields.filter((e)=>e.group === "contact1") as nf}
            <IFTAInput 
                type={(nf.type !== undefined) ? nf.type : ""} 
                label={(nf.label !== undefined) ? nf.label : ""} 
                placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                name={nf.name}
                show_error={nf.show_error}
                error_text={nf.error_text}
                disabled={nf.disabled}
                bind:value={nf.value}
                bind:validation_function={nf.validation_function}
                bind:extFuncs={nf.ext_funcs}
            />
            {/each}
        </div>

        <div class="ff serviceinforow">
            {#each fields.filter((e)=>e.group === "service1") as nf}
            <IFTAInput 
                type={(nf.type !== undefined) ? nf.type : ""} 
                label={(nf.label !== undefined) ? nf.label : ""} 
                placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                name={nf.name}
                show_error={nf.show_error}
                error_text={nf.error_text}
                bind:change_function={nf.change_function}
                bind:value={nf.value}
                bind:validation_function={nf.validation_function}
                bind:extFuncs={nf.ext_funcs}
            />
            {/each}
        </div>
        <div class="ff serviceinforow">
            {#each fields.filter((e)=>e.group === "service2") as nf}
            <IFTAInput 
                type={(nf.type !== undefined) ? nf.type : ""} 
                label={(nf.label !== undefined) ? nf.label : ""} 
                placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                name={nf.name}
                show_error={nf.show_error}
                error_text={nf.error_text}
                bind:change_function={nf.change_function}
                bind:value={nf.value}
                bind:hidden={nf.hidden}
                bind:validation_function={nf.validation_function}
                bind:extFuncs={nf.ext_funcs}
            />
            {/each}
        </div>
        <div class="ff serviceinforow">
            {#each fields.filter((e)=>e.group === "service3") as nf}
            <IFTAInput 
                type={(nf.type !== undefined) ? nf.type : ""} 
                label={(nf.label !== undefined) ? nf.label : ""} 
                placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                name={nf.name}
                show_error={nf.show_error}
                error_text={nf.error_text}
                maxlength={nf.maxlength}
                bind:change_function={nf.change_function}
                bind:value={nf.value}
                bind:validation_function={nf.validation_function}
                bind:extFuncs={nf.ext_funcs}
            />
            {/each}
        </div>
    </div>

    <div class="section photoinfo">
        <div class="sectiontitle"><i class="fas fa-info-circle"></i> Photos</div>
        <div class="sectioninfo">
            <div class="photo-list">
                {#each photos as photo, index}
                {#if !photo.deleted}
                <div class="photo-item">
                    <img class="photo" src="{photo.body}" alt="d" />
                    <button on:click={()=>{ onFileRemoved(index); }}><i class="fas fa-trash"></i> Delete</button>
                </div>
                {/if}
                {/each}
            </div>
            <div style="margin: 10px;">
                <button on:click={()=>{fileinput.click();}} style="background-color: #1769aa; color: white;" disabled={is_busy}>Add Photo</button>
                <input style="display:none" type="file" accept=".jpg, .jpeg, .png" on:change={(e)=>onFileSelected(e)} bind:this={fileinput} multiple>
            </div>

        </div>
    </div>

    <div class="updatebuttonholder">
        <div class="updatebutton">
            <button on:click={() => {updateJob();}} disabled={is_busy}>Update Job</button>
        </div>
        <div class="backbutton">
            <button on:click={()=>{pop();}} disabled={is_busy}><i class="fas fa-arrow-circle-left"></i> Back</button>
        </div>
    </div>
</div>

<style>
    .ff {
        padding: 10px;
        width: 100%;
    }
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }
    :global(.center-block) {
        margin: auto;
        display: block;
        width: 90%;
        border-width:0px;
        border:none;
    }
    .sectioninfo {
        padding: 20px;
    }
    .mockgroupitem {
        width: 100%;
        border: solid 1px #ccc;
        border-radius:6px;
        padding-top: 15px;
        background-color: white;
        margin-bottom: 15px;
    }
    .contentholder {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-template-rows: auto;
        grid-template-areas: "ci ci ci ci ci ci ci ci ci ci ci ci"
                             "si si si si si si si si si si si si"
                             "pi pi pi pi pi pi pi pi pi pi pi pi"
                             "wi wi wi wi wi wi wi wi wi wi wi wi"
                             "ts ts ts ts ts ts ts ts ts ts ts ts"
                             "py py py py py py py py py py py py"
                             "ub ub ub ub ub ub ub ub ub ub ub ub";
        gap: 20px;
    }
    .infoitem {
        display: flex;
        flex-direction: row;
    }
    .infoitem .infoitemtitle {
        width: 80px;
        font-weight: bold;
        text-align: left;
        word-wrap: break-word;
        hyphens: auto;
    }
    .infoitem .infoitemvalue {
        text-align: left;
        margin-left: 10px;
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
    }
    .clientinfo {
        grid-area: ci;
    }
    .pricinginfo {
        grid-area: pi;
    }
    .pricinginforow {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .contractorinfo {
        grid-area: wi;
    }
    .contractorinforow {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .formrow {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0px;
    }
    .serviceinfo {
        grid-area: si;
    }
    .photoinfo {
        grid-area: py;
    }
    .timesheetinfo {
        grid-area: ts;
    }
    .serviceinforow {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .updatebuttonholder {
        grid-area: ub;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .updatebuttonholder button {
        padding-left: 20px;
        padding-right: 20px;
        margin-right: 10px;
    }
    .updatebutton button {
        background-color: #357a38;
        color: white;
    }
    .backbutton button {
        background-color: #ff9100;
        color: white;
    }
    .mockgroupitem {
        width: 100%;
        border: solid 1px #ccc;
        border-radius:6px;
        padding-top: 15px;
    }
    .section {
        background-color: #ccc;
    }
    .photo-list {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .photo-item {
        display: flex;
        flex-direction: column;
        margin: 10px;
    }
	.photo{
		height: 100px;
		width: 100px;
	}
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .ff {
            padding: 10px;
            width: 100%;
        }
        .contentholder {
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            grid-template-rows: auto;
            grid-template-areas: "ci ci"
                                 "si si"
                                 "li li"
                                 "pi pi"
                                 "wi wi"
                                 "ts ts"
                                 "py py"
                                 "ub ub";
            gap: 20px;

        }
        .infoitem {
            width: 100%;
            display: flex;
            flex-direction: row;
        }
        .infoitem .infoitemtitle {
            font-weight: bold;
            text-align: right;
            overflow-wrap: break-word;
            word-wrap: break-word;
            hyphens: auto;
        }
        .infoitem .infoitemvalue {
            text-align: left;
            margin-left: 10px;
            overflow-wrap: break-word;
            word-wrap: break-word;
            hyphens: auto;
        }
        .clientinfo {
            grid-area: ci;
        }
        .pricinginfo {
            grid-area: pi;
        }
        .photoinfo {
            grid-area: py;
        }
        .pricinginforow {
            width: 100%;
            padding: 0px;
            display: flex;
            flex-direction: column;
        }
        .contractorinfo {
            grid-area: wi;
        }
        .contractorinforow {
            width: 100%;
            padding: 0px;
            display: flex;
            flex-direction: column;
        }
        .serviceinfo {
            grid-area: si;
        }
        .serviceinforow {
            width: 100%;
            padding: 0px;
            display: flex;
            flex-direction: column;
        }
        .updatebuttonholder {
            grid-area: ub;
            width: 100%;
            display: flex;
            flex-direction: column;
            
        }
        .updatebuttonholder button {
            width: 100%;
            margin-right: 10px;
        }
        .updatebutton button {
            background-color: #357a38;
            color: white;
        }
        .backbutton button {
            background-color: #ff9100;
            color: white;
        }
        .formrow {
            width: 100%;
            padding: 0px;
            display: flex;
            flex-direction: column;
        }
    }
</style>